import {
  selectEmail,
  selectFirstName,
  selectLastName,
  selectUserAvatarUrl,
} from 'core/userContext/selectors';
import { useSelector } from 'react-redux';
import { AVATAR_SIZES } from 'ui/avatar/constants';
import { Settings } from 'ui/icons/action/Settings';
import {
  Avatar,
  Email,
  FullName,
  IconWrapper,
  ProfileLink,
  ProfileWrapper,
} from './AccountsAndProjectsMenu.styles';

export const Profile = () => {
  const firstName = useSelector(selectFirstName);
  const lastName = useSelector(selectLastName);
  const userAvatarUrl = useSelector(selectUserAvatarUrl) || '';
  const email = useSelector(selectEmail);
  return (
    <ProfileWrapper data-test="profile-details">
      <ProfileLink data-test="profile-link" to="/preferences">
        <Avatar
          firstName={firstName}
          lastName={lastName}
          imgSrc={userAvatarUrl}
          size={AVATAR_SIZES.MEDIUM}
        />
        <FullName data-test="profile-username">{`${firstName} ${lastName}`}</FullName>
        <Email>{email}</Email>
        <IconWrapper>
          <Settings isColorInherited />
        </IconWrapper>
      </ProfileLink>
    </ProfileWrapper>
  );
};
